import { render, staticRenderFns } from "./CallDetailFilter.vue?vue&type=template&id=e23072e2"
import script from "./CallDetailFilter.vue?vue&type=script&lang=js"
export * from "./CallDetailFilter.vue?vue&type=script&lang=js"
import style0 from "./CallDetailFilter.vue?vue&type=style&index=0&id=e23072e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports